const m = require('air-vue-model')()
m.url = 'equipment_config_services'
m.name = 'equipmentConfigService'

module.exports = m